<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 0; overflow: hidden;position: fixed;background-color: rgb(27, 28, 29)">
        <vue-cesium v-if="cesiumOptions"
                    style="width: calc(100% - 60px); height: 100%; margin: 0; padding: 0; overflow: hidden;position: relative"
                    :options="cesiumOptions"
                    :defaultViewPoint="defaultViewPoint"
                    @initialized="onCesiumInitialized"
        >
            <div style="width: 100%; height: 100%; margin: 0; padding: 0;position:absolute">
                <cesium-clock-widget
                        :controlsColor="'rgb(33, 133, 208)'"
                        @multiplierChanged="e => this.multiplier = e"
                        @currentTimeChanged="e => this.currentTime = e"
                />
                <cesium-clock
                        :multiplier="multiplier"
                        :currentTime="currentTime"
                />
                <cesium-timeline
                        :entities="timelineEntities"
                        :zoomMax="zoomMax"
                        :initRange="timelineInitRange"
                        @currentTimeChanged="e => this.currentTime = e"
                        @currentIntervalChanged="({start, end}) => {this.timeLineStartTime = start; this.timeLineEndTime = end;}"
                        @itemSelected="e => this.selectedGroundTrack = e?e.id:null"
                />
                <cesium-entities-czml-data-source
                        :entities="satellites"
                        :maxDiffTimeForExecute="1800000"
                        :czmlParamsPromiseFun="satellitesCzmlDataSourceParamsPromiseFun"
                        :entityCzmlTemplate="satellitesCzmlDataSourceEntityCzmlTemplate"
                />
                <cesium-entities-wms-data-source
                        :entities="images"
                />
                <cesium-aoi-select v-if="createNewAoi&&coords"
                                   :coords="coords"
                                   :color="aoiRectangleColor"
                                   :sizeConstraints="aoiSelectSizeConstraints"
                                   @aoiUpdated="onAoiUpdated"
                                   @drugStart="onAoiDragStart"
                />
                <cesium-rectangle-create v-if="createNewAoi&&!coords"
                                         :sizeConstraints="aoiSelectSizeConstraints"
                                         :color="aoiRectangleColor"
                                         :disabled="cameraHeight > heightLimit"
                                         @created="onAoiUpdated"
                />
                <cesium-polyline v-if="createNewAoi&&coords||selectedAoi!==null"
                                 :polylines="polylines"
                />
                <cesium-rectangle v-if="selectedAoi!==null"
                                  :color="aoiRectangleColor"
                                  :rectangles="selectedAoiRectangles"
                />
            </div>
        </vue-cesium>
        <side-panel
                :menuItems="sidePanelMenuItems"
                :selectedItem.sync="selectedMenuItem"
        >
            <aoi-list slot="1"
                      :aois="userAois"
                      :isDisabled="createNewAoi"
                      @addButtonClick="onAddAoiButtonClick"
                      @copyButtonClick="onCopyButtonClick"
                      @removeButtonClick="onRemoveAoiButtonClick"
                      @downloadResultButtonClick="onDownloadResultButtonClick"
                      :selectedAoi.sync="selectedAoi"
            />

            <admin-aoi-list slot="2"
                            :aois="aois"
                            @removeButtonClick="onRemoveAoiButtonClick"
                            @entityUpdated="updateAoi"
                            :selectedAoi.sync="selectedAoi"
                            :uploadURL="imagesUploadUrl"
                            @downloadResultButtonClick="onDownloadResultButtonClick"
                            :idToken="idToken"
            />

            <request-aoi-list slot="3"
                              :aois="requestAois"
                              :requestConfig="requestConfig"
                              @requestConfigUpdated="updateRequestConfig"
                              @entityUpdated="updateAoi"
                              :selectedAoi.sync="selectedAoi"
            />

            <div slot="menu-bottom" style="margin-bottom: 10px">
                <div style="width: 100%;">
                    <div style="margin-bottom: 10px">
                        <v-btn flat icon color="blue-grey lighten-4"
                               v-if="videoId"
                               title="Справка"
                               @click="onHelpButtonClick">
                            <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                    </div>
                    <user-panel/>
                </div>
            </div>
        </side-panel>
        <div v-if="createNewAoi"
             style="position: absolute; top: 5px; left: 15px; display: flex; flex-direction: column; align-items: flex-start;">
            <template v-if="coords">
                <div style="background-color: rgba(27, 28, 29, 0.8); padding: 10px 15px 0;border-radius: 0.5rem 0.5rem 0 0">
                    <h4 style="color: white; text-align: left; margin-bottom: 0;">
                        Интервал съемки
                    </h4>
                </div>
                <div style="background-color: rgba(27, 28, 29, 0.8); padding: 10px;  border-radius: 0 0.5rem 0.5rem 0.5rem">
                    <div style="display: flex; align-items:center">
                        <date-range-picker
                                style="margin-right: 20px"
                                :dateRangeLimit="dateRangeLimit"
                                v-model="selectedDateInterval"
                        />
                        <button class="ui small primary button"
                                style="margin: 0"
                                @click="onSaveAoiButtonClick">
                            Сохранить
                        </button>
                        <button
                                class="ui small inverted basic  button"
                                style="margin-left: 10px;margin-right: 0"
                                @click="onCancelAoiCreatingButtonClick">
                            Отмена
                        </button>
                    </div>
                </div>
            </template>
            <div v-else
                 style="line-height: 40px;background-color: rgba(27, 28, 29, 0.8); padding: 10px;  border-radius: .5rem;">
                <div style="color: white; font-size: 1.25em; display: inline-block;margin-right: 20px">
                    {{(cameraHeight < heightLimit)?'Выберите область наблюдения':'Приблизьте камеру'}}
                </div>
                <button
                        class="ui small inverted basic  button"
                        style="margin-left: 10px;margin-right: 0"
                        @click="onCancelAoiCreatingButtonClick">
                    Отмена
                </button>
            </div>
        </div>
        <v-help v-if="videoId"
                :isOpen.sync="showHelp"
                :videoId="videoId"
        />
    </div>
</template>

<script>
    import Vue from 'vue'

    import {
        VueCesium,
        CesiumClockWidget,
        CesiumClock,
        CesiumTimeline,
        CesiumEntitiesCzmlDataSource,
        CesiumEntitiesWmsDataSource,
        CesiumAoiSelect,
        CesiumPolyline,
        CesiumRectangle,
        CesiumComponentMixin,
        CesiumRectangleCreate,
        commonUtils,
        cesiumUtils
    } from 'vue-cesium'

    import {eciFromTLE, cartesianFromTLE, visibles} from 'ballistics'

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faMapMarkedAlt, faUsers, faFileInvoice} from '@fortawesome/free-solid-svg-icons'

    library.add(faMapMarkedAlt, faUsers, faFileInvoice);

    import SidePanel from '@/components/side-panel/side-panel'
    import DateRangePicker from '@/components/date-range-picker/date-range-picker'
    import UserPanel from '@/components/user-panel/user-panel'
    import AoiList from '@/components/aoi-list/aoi-list'
    import AdminAoiList from '@/components/admin-aoi-list/admin-aoi-list'
    import RequestAoiList from '@/components/request-aoi-list/request-aoi-list.vue'
    import VHelp from '@/components/v-help/v-help.vue'

    import SunCalc from 'suncalc'

    import {cloneDeep} from 'lodash/lang'
    import {find} from 'lodash/collection'
    import {unionBy} from 'lodash/array'

    import 'semantic-ui-css/components/button.css'
    import 'semantic-ui-css/components/image.css'

    import firebase from 'firebase/app'
    import 'firebase/firestore'
    import 'firebase/auth'

    import satellitesCzmlDataSourceEntityCzmlTemplate from './czml-tempates/satellitesCzmlDataSourceEntityCzmlTemplate'

    const APP_CONFIG = require('../../../app-config-' + process.env.VUE_APP_MODE + '.json');

    const dayMillis = 24 * 60 * 60 * 1000;

    export default {
        props: [],
        mixins: [CesiumComponentMixin],
        data() {
            const currentTime = Date.now();
            const dateRangeLimit = 10;

            const {uid} = firebase.auth().currentUser;

            const db = firebase.firestore();

            return {
                currentTime,
                zoomMax: 365 * dayMillis,
                timeLineStartTime: Date.now() - (dateRangeLimit - 1) / 2 * dayMillis,
                timeLineEndTime: Date.now() + (dateRangeLimit - 1) / 2 * dayMillis,
                multiplier: 1,
                visibility: [],
                aois: [],
                userAois: [],
                requestAois: [],
                aoisCollection: db.collection('aois'),
                requestConfigRef: db.collection('auth').doc(uid).collection('configs').doc('requestConfig'),
                requestConfig: null,
                satellitesCzmlDataSourceEntityCzmlTemplate,
                createNewAoi: false,
                showHelp: false,
                coords: null,
                selectedDateInterval: {
                    start: Date.now(),
                    end: Date.now() + (dateRangeLimit - 1) * dayMillis
                },
                selectedGroundTrack: null,
                selectedGroundTrackColor: [1, 1, 0, 1],
                aoiRectangleColor: [1, 0.5, 0.25, 0.3],
                selectedAoi: null,
                isAdmin: false,
                selectedMenuItem: 1,
                cameraHeight: null,
                fireBaseAppConfig: null,
                firebaseSatellites: null,
                idToken: null,
                defaultViewPoint: [53.20007, 50.15, 20000000]
            }
        },

        firestore() {
            const db = firebase.firestore();

            const {uid: userUID} = firebase.auth().currentUser;

            const userAois = this.aoisCollection.where('userUID', '==', userUID).orderBy("creationTime", "desc");

            const fireBaseAppConfig = db.collection('app-config').doc('main');

            return {
                aois: userAois,
                userAois,
                requestConfig: this.requestConfigRef,
                fireBaseAppConfig: fireBaseAppConfig,
                firebaseSatellites: fireBaseAppConfig.collection('satellites')
            }
        },
        mounted() {
            firebase.auth().currentUser.getIdTokenResult()
                .then(({claims, token}) => {
                    this.idToken = token;

                    const isAdmin = !!claims.admin;
                    this.isAdmin = isAdmin;

                    if (isAdmin) {
                        this.$bind('aois', this.aoisCollection.orderBy("creationTime", "desc"));
                        this.$bind('requestAois', this.aoisCollection.where('status', '==', 'inProcessing').orderBy("creationTime", "desc"));
                    }
                })
        },
        computed: {
            sidePanelMenuItems() {
                const menuItems = [
                    {
                        id: 1,
                        icon: 'map-marked-alt',
                        label: 'Области наблюдения'
                    }
                ];

                if (this.isAdmin) {
                    menuItems.push({
                        id: 2,
                        icon: 'users',
                        label: 'Области наблюдения всех пользователей'
                    });

                    menuItems.push({
                        id: 3,
                        icon: 'file-invoice',
                        label: 'Заявка на съемку'
                    });
                }

                return menuItems;
            },
            timelineInitRange() {
                return {
                    start: this.timeLineStartTime,
                    end: this.timeLineEndTime
                }
            },
            polylines() {
                return this.visibility.map(({id, groundTrack}) => (
                    {
                        color: this.selectedGroundTrack === id ? this.selectedGroundTrackColor : undefined,
                        coords: groundTrack.map(p => p.coords)
                    }
                ));
            },
            selectedAoiEntities() {
                return this.aois.filter(({id}) => id === this.selectedAoi);
            },
            selectedAoiRectangles() {
                return this.selectedAoiEntities.map(({coords, id}) => ({
                    coords,
                    id
                }));
            },
            timelineEntities() {
                return [...this.visibility]
                    .sort((a, b) => a.startTime - b.startTime)
                    .map(({id, rectangle, startTime}, index) => {
                            const {longitude, latitude} = this.center(rectangle);
                            return {
                                id,
                                label: 'Трасса ' + (index + 1),
                                startTime: startTime,
                                position: {
                                    lat: latitude,
                                    lng: longitude,
                                    alt: this.diagonalLength(rectangle) * 2
                                }
                            }
                        }
                    )
            },
            heightLimit() {
                const {maxWidth, maxHeight} = this.aoiSelectSizeConstraints;
                const maxDiagonalLenght = Math.sqrt(maxWidth ** 2 + maxHeight ** 2);
                return maxDiagonalLenght * 4;
            },
            cesiumOptions() {
                return !this.appConfig ? null : {
                    baseLayerPicker: false,
                    homeButton: false,
                    navigationHelpButton: false,
                    fullscreenButton: false,
                    infoBox: false,
                    timeLine: false,
                    shouldAnimate: true,
                    imageryProvider: "{new Cesium.BingMapsImageryProvider({ url : 'https://dev.virtualearth.net',key : '" +
                        this.appConfig.BING_MAPS_KEY +
                        "', mapStyle : Cesium.BingMapsStyle.AERIAL_WITH_LABELS})}"
                };
            },
            videoId() {
                return (this.appConfig || {}).YOUTUBE_VIDEO_ID
            },
            satellites() {
                return unionBy((this.firebaseSatellites || []), APP_CONFIG.satellites).map(({id, label, tleStr1, tleStr2}) => ({
                    id, label, tle: {str1: tleStr1, str2: tleStr2}
                }))
            },
            aoiSelectSizeConstraints() {
                const {aoiMaxWidth, aoiMaxHeight} = (this.appConfig || {});

                return {
                    maxWidth: aoiMaxWidth || Infinity,
                    maxHeight: aoiMaxHeight || Infinity
                }
            },
            dateRangeLimit() {
                const {dateRangeLimit} = (this.appConfig || {});
                return dateRangeLimit !== undefined ? dateRangeLimit : 10;
            },
            minAngleElavation() {
                const {minAngleElavation} = (this.appConfig || {});
                return minAngleElavation !== undefined ? minAngleElavation : 10;
            },
            minSunAltitude() {
                const {minSunAltitude} = (this.appConfig || {});
                return minSunAltitude !== undefined ? minSunAltitude : 10;
            },
            visibilitySettings() {
                return (this.appConfig || {}).visibilitySettings || {}
            },

            images() {
                return this.selectedAoiEntities.map(({id, images}) => {
                    if (!images) return;
                    const [image] = images;
                    if (!image) return;
                    const {wmsUrl} = image;
                    return {
                        id,
                        url: wmsUrl + "&format=image/png&transparent=true"
                    }
                }).filter(i => i);
            },
            imagesUploadUrl() {
                return (this.appConfig || {}).imagesUploadUrl || "";
            },
            appConfig() {
                return Object.assign({}, APP_CONFIG, (this.fireBaseAppConfig || {}));
            }
        },
        methods: {
            satellitesCzmlDataSourceParamsPromiseFun(entity, currentTime) {
                const duration = 2.5 * 3600 * 1000;

                const startTime = currentTime - duration / 2;
                const step = 60 * 1000;

                return new Promise((resolve) => {
                        return resolve([...cartesianFromTLE(entity.tle, startTime, duration, step)]);
                    }
                )
                    .then(position => commonUtils.normalizeArray(position))
                    .then(position => ({position, startTime, step, duration}));
            },
            visibilityCalculation(rectangle, dateInterval) {
                if (!rectangle) {
                    this.visibility = [];
                    return;
                }

                let start = new Date(dateInterval.start);
                start.setHours(0, 0, 0, 0);
                start = start.valueOf();

                let end = new Date(dateInterval.end);
                end.setHours(23, 59, 59, 999);
                end = end.valueOf();

                const {longitude, latitude, height} = this.center(rectangle);

                this.visibility = this.satellites.map(satellite => {

                    const {tle} = satellite;

                    const duration = end - start;

                    const visibility = [...visibles(
                        tle, start, duration,
                        {longitude, latitude, altitude: height},
                        Cesium.Math.toRadians(this.minAngleElavation),
                        this.visibilitySettings,
                        {
                            percentDurationRevolution: 0.8,
                            minDurationVisible: 60 * 1000, //мс
                            accuracyAngleElevation: Cesium.Math.toRadians(0.1), //рад
                            epselenAngleElevation: 100,//мс
                            epselenDistance: 100 //мс
                        }
                    )];

                    let positions = visibility.map(vis =>
                        [...eciFromTLE(tle, vis.startTime, vis.endTime - vis.startTime, 15 * 1000)]
                            .map(([time, x, y, z]) => ({
                                time: vis.startTime + time * 1000,
                                coords: Cesium.Ellipsoid.WGS84.cartesianToCartographic(new Cesium.Cartesian3(x, y, z))
                            }))
                            .map(p => {
                                p.coords.height = 0;
                                return p;
                            })
                    );

                    positions = positions.filter(position =>
                        position.every(p => {
                            const {altitude} = SunCalc.getPosition(new Date(p.time), Cesium.Math.toDegrees(p.coords.latitude), Cesium.Math.toDegrees(p.coords.longitude));
                            return altitude > Cesium.Math.toRadians(this.minSunAltitude);
                        })
                    );

                    return positions.map(position => ({
                        id: commonUtils.generateid(),
                        groundTrack: position,
                        satellite,
                        rectangle,
                        startTime: position[0].time,
                        endTime: position[position.length - 1].time
                    }));
                }).reduce((accumulator, currentValue) => accumulator.concat(currentValue));
            },
            center(rectangle) {
                return Cesium.Rectangle.center(rectangle);
            },
            diagonalLength({west, north, east, south}) {
                return cesiumUtils.lineLength(
                    {
                        longitude: west,
                        latitude: north
                    },
                    {
                        longitude: east,
                        latitude: south
                    }
                );
            },

            onCesiumInitialized() {
                const viewer = this.getViewer();

                const ellipsoid = viewer.scene.mapProjection.ellipsoid;
                const camera = viewer.scene.camera;
                const cartographic = new Cesium.Cartographic();

                viewer.clock.onTick.addEventListener(() => {
                    const {height} = ellipsoid.cartesianToCartographic(camera.positionWC, cartographic);
                    this.cameraHeight = height;
                });
            },

            flyTo(longitude, latitude, altitude) {
                this.getViewer().camera.flyTo({
                    destination: Cesium.Cartesian3.fromRadians(longitude, latitude, altitude)
                });
            },
            onAoiUpdated(e) {
                this.coords = e;
            },
            onAoiDragStart() {
                this.visibility = [];
            },
            onAddAoiButtonClick() {
                if (this.createNewAoi) return;
                this.coords = null;
                this.createNewAoi = true;

            },
            onCancelAoiCreatingButtonClick() {
                this.createNewAoi = false;
                this.visibility = [];
            },
            getGeoInfo(longitude, latitude) {
                return this.$axios.get(this.appConfig.OSM_REVERSE_URL || 'https://nominatim.openstreetmap.org/reverse', {
                    params: {
                        format: 'json',
                        lon: Cesium.Math.toDegrees(longitude),
                        lat: Cesium.Math.toDegrees(latitude)
                    }
                }).then(response => response.data);
            },
            onSaveAoiButtonClick() {
                const {longitude, latitude} = Cesium.Rectangle.center(this.coords);

                this.getGeoInfo(longitude, latitude)
                    .then(geoInfo => {
                        const {uid} = firebase.auth().currentUser;
                        return this.addAoi({
                            userUID: uid,
                            userData: firebase.firestore().collection('auth').doc(uid),
                            creationTime: Date.now(),
                            status: 'created',
                            label: geoInfo.display_name || 'Неизвестная область',
                            coords: cloneDeep(this.coords),
                            center: {
                                longitude, latitude
                            },
                            start: this.selectedDateInterval.start,
                            end: this.selectedDateInterval.end
                        });
                    });

                this.createNewAoi = false;
                this.visibility = [];
            },
            onRemoveAoiButtonClick(aoiId) {
                this.removeAoi(aoiId);
            },
            onDownloadResultButtonClick(aoiId) {
                const {images} = find(this.aois, ({id}) => aoiId === id);

                if (images) {
                    const [image] = images;
                    if (!image) return;
                    const {downloadUrl} = image;

                    downloadURI(downloadUrl);
                }

                function downloadURI(uri) {
                    let link = document.createElement("a");
                    link.href = uri;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            },
            onCopyButtonClick(aoiId) {
                const {coords, start, end} = find(this.aois, ({id}) => aoiId === id);
                this.coords = cloneDeep(coords);
                this.createNewAoi = true;
                this.selectedDateInterval = {start, end};
                const {longitude, latitude} = this.center(coords);
                this.flyTo(longitude, latitude, this.diagonalLength(coords) * 2);
            },
            onHelpButtonClick() {
                this.showHelp = true;
            },
            updateAoi(val) {
                if (Array.isArray(val))
                    val.forEach(v => this.aoisCollection.doc(v.id).update(v.data));
                else
                    this.aoisCollection.doc(val.id).update(val.data);
            },
            addAoi(aoi) {
                this.aoisCollection.add(aoi);
            },
            removeAoi(aoiId) {
                this.aoisCollection.doc(aoiId).delete();
            },
            updateRequestConfig(val) {
                this.requestConfigRef.set(val);
            }
        },
        watch: {
            coords(newVal) {
                this.visibilityCalculation(newVal, this.selectedDateInterval);
            },
            selectedDateInterval({start, end}) {
                this.visibilityCalculation(this.coords, {start, end});

                this.timeLineStartTime = start - dayMillis;
                this.timeLineEndTime = end + dayMillis;
            },
            selectedAoiEntities(newVal) {
                if (newVal.length) {
                    const [aoi] = newVal;

                    const {start, end, coords, status} = aoi;

                    if (status !== "done") {
                        this.visibilityCalculation(coords, {start, end});
                        this.timeLineStartTime = start - dayMillis;
                        this.timeLineEndTime = end + dayMillis;
                    } else this.visibility = [];

                    const {longitude, latitude} = this.center(coords);
                    this.flyTo(longitude, latitude, this.diagonalLength(coords) * 2);
                } else this.visibility = [];
            },
            selectedMenuItem() {
                this.selectedAoi = null;
            },
            dateRangeLimit(newVal) {
                this.coords = null;
                this.selectedDateInterval = {
                    start: Date.now(),
                    end: Date.now() + (newVal - 1) * dayMillis
                };
                this.timeLineStartTime = Date.now() - (newVal - 1) / 2 * dayMillis;
                this.timeLineEndTime = Date.now() + (newVal - 1) / 2 * dayMillis;
            }
        },
        components: {
            VueCesium,
            SidePanel,
            CesiumClockWidget,
            CesiumClock,
            CesiumTimeline,
            CesiumEntitiesCzmlDataSource,
            CesiumAoiSelect,
            CesiumPolyline,
            CesiumRectangle,
            DateRangePicker,
            UserPanel,
            CesiumRectangleCreate,
            VHelp,
            AoiList,
            AdminAoiList,
            RequestAoiList,
            CesiumEntitiesWmsDataSource
        }
    }
</script>

<style scoped>

</style>
